import { render, staticRenderFns } from "./academic_course_detail.vue?vue&type=template&id=663a4651&scoped=true&"
import script from "./academic_course_detail.vue?vue&type=script&lang=js&"
export * from "./academic_course_detail.vue?vue&type=script&lang=js&"
import style0 from "./academic_course_detail.vue?vue&type=style&index=0&id=663a4651&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663a4651",
  null
  
)

export default component.exports